import { BankingSessionStatusPanelDictionary } from 'types/i18n';
import { UnreachableError } from 'utils/errors';

export const bankingSessionStatusPanelDictionaryRu: BankingSessionStatusPanelDictionary = {
  statusPendingText: 'Проверка связи...',
  statusActiveText(bankName) {
    switch (bankName) {
      case 'PRIOR':
        return 'Связь с Приорбанком установлена.';
      case 'NBRB':
        return 'Связь с НБРБ установлена.';
      default:
        throw new UnreachableError(bankName);
    }
  },
  statusInactiveText(bankName) {
    switch (bankName) {
      case 'PRIOR':
        return 'Нет связи с Приорбанком.';
      case 'NBRB':
        return 'Нет связи с НБРБ.';
      default:
        throw new UnreachableError(bankName);
    }
  },
  refreshButton: 'Обновить',
  generateTokensButton: 'Сгенерировать токены',
  dialogTitle: 'Отправьте эту ссылку главбуху',
  dialogCloseButton: 'Закрыть',
  dialogCopyButton: 'Копировать',
};
